import React, { useRef, useState } from "react";
import * as notify from "../shared/notify";

import TaskNav from "../components/task-nav/task-nav";
import NotificationBar from "../components/notification-bar";

import { uploadContent } from "./lib/upload-content";

const ErrorList = (props) => {
    const errors = props.errors.map((error, index) => {
        return <NotificationBar key={`error_${index}`} type="error" message={error.message} />;
    });

    return <div className="error-list">{errors}</div>;
};

const UploadContentIndex = () => {
    const fileInput = useRef();
    const [state, setState] = useState({
        file: "",
        workflowType: 1,
        errors: [],
    });

    const onUpload = async () => {
        if (!state.files || !state.files[0]) {
            notify.error("File must be selected");

            return;
        }

        const response = await uploadContent(state);

        if (response && response.errors && response.errors.length > 0) {
            setState({
                files: "",
                workflowType: 1,
                errors: response.errors,
            });
            fileInput.current.value = "";

            return;
        }

        if (response.success === false) {
            return notify.error("You do not have permission to perform this action.");
        }

        setState({
            files: "",
            workflowType: 1,
            errors: [],
        });
        fileInput.current.value = "";

        notify.success("Upload Successful");
    };

    const onFileChange = (event) => {
        let files = event.target.files;

        setState({
            files: files,
            workflowType: 1,
            errors: [],
        });
    };

    return (
        <div>
            <TaskNav>
                <div className="button-group -right">
                    <h1>Upload Content</h1>
                    <button className="button -primary" onClick={onUpload}>
                        Upload
                    </button>
                </div>
            </TaskNav>

            <div>
                <input type="file" ref={fileInput} onChange={onFileChange} accept=".csv"></input>
                <br />
                <br />
            </div>
            <ErrorList errors={state.errors} />
        </div>
    );
};

export default UploadContentIndex;
